import React, { useContext, useEffect } from 'react'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import '../Login/Login.css'
import { mapData, handleRedirectInternal } from '@/product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useHistory } from 'react-router-dom'
import UserContext from '@/product/context/user/userContext'
import AlertContext from '@/product/context/alert/alertContext'
const ResetComponent = (props) => {
    const userContext = useContext(UserContext)
    const { resetAdminPassword, responseStatus, clearResponse } = userContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const history = useHistory()
    const formik = useFormik({
        initialValues: props.initialValues,
        validationSchema: props.validationArray,
        onSubmit: (values) => {
            resetAdminPassword(values)
        },
    })

    const resetPasswordData = {
        formik: formik,
        data: props.resetPasswordData,
    }

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'resetAdminPassword') {
                if (responseStatus.status === 'success') {
                    if (props.onSuccess) {
                        props.onSuccess()
                    } else {
                        setAlert(
                            responseStatus.message || 'Successfully',
                            responseStatus.status || 'success'
                        )
                        clearResponse()
                        handleRedirectInternal(history, '')
                    }
                }
            }
        }
    }, [responseStatus])

    return (
        <form onSubmit={formik.handleSubmit} autoComplete="nofill">
            <div className="row">
                {mapData(resetPasswordData)}
                <div className="col-12">
                    <PrimaryButton
                        id="passwordData_change"
                        type="submit"
                        label={'change'}
                    />
                </div>
            </div>
        </form>
    )
}
export default ResetComponent
